import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=fed0dfd4&scoped=true&"
import script from "./Greeting.vue?vue&type=script&lang=ts&"
export * from "./Greeting.vue?vue&type=script&lang=ts&"
import style0 from "./Greeting.vue?vue&type=style&index=0&id=fed0dfd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed0dfd4",
  null
  
)

export default component.exports